export const getUploadConfig = () => ({
	config: window.frmUpload?.config || {},
	i18n: window.frmUpload?.i18n || {},
	rest: window.frmUpload?.rest || {},
});
